<template>
  <SogForm
    ref="_form"
  >
    <SogFormField>
      <SogNumericTextBox
        v-model="_default"
        placeholder="Standard Anzahl Tage"
        name="Default"
        format="N"
        :min="1"
      />
    </SogFormField>
    <SogFormField>
      <SogNumericTextBox
        v-model="_max"
        placeholder="Maximale Anzahl Tage"
        name="max"
        format="N"
        :min="1"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import Person from "@/shared/model/person";

const _form = ref<InstanceType<typeof SogForm> | null>(null)

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  person: undefined,
  details: undefined
})

const _default = ref<number>(0)
const _max = ref<number>(0)


function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _default.value = props.details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration) ?? (props.person?.isBranch() ? 7 : 30)
  _max.value = props.details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration) ?? (props.person?.isBranch() ? 30 : 90)
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setNumberValue(PersonDetailsId.EvbActivationDefaultDuration, _default.value)
  details.setNumberValue(PersonDetailsId.EvbActivationMaxDuration, _max.value)
  return details;
}

defineExpose({
  validate,
  getDetails
})
</script>

<style scoped>

</style>
